import { createFileRoute } from '@tanstack/react-router';
import { ensureLoaded } from '@/lib/ensure-loaded';
import { pastVideoSetQuery } from '@/services/past-videos';
import { myRoleQuery } from '@/services/team-members';
import { parsePastVideoSearch } from '@/features/past-videos/search';
import { SetPage } from '@/features/past-videos/set-page';

// One group of past videos (its home is Artifacts' Past videos tab): the check on view (`run`), the one it is compared
// with (`against`), the open video, the view. A group she can't open, or a read that fails, is the page's to say (never
// the route's error card).
export const Route = createFileRoute('/_authed/past-videos/$setId')({
  validateSearch: parsePastVideoSearch,
  loaderDeps: ({ search }) => ({ run: search.run ?? null, against: search.against ?? null }),
  loader: ({ context: { queryClient, team }, params, deps }) =>
    team
      ? Promise.all([
          ensureLoaded(queryClient, pastVideoSetQuery(team.id, params.setId, deps.run, deps.against)).catch(() => null),
          ensureLoaded(queryClient, myRoleQuery(team.id)).catch(() => null),
        ])
      : undefined,
  component: SetRoute,
});

function SetRoute() {
  const { setId } = Route.useParams();
  const search = Route.useSearch();
  return <SetPage setId={setId} search={search} />;
}
